<template>

    <el-row class="container">
        <el-col :span="24" class="header">
            <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
                {{collapsed?'':sysName}}
            </el-col>
            <!--<el-col :span="10">
                <div class="tools" @click.prevent="collapse">
                    <i class="fa fa-align-justify"></i>
                </div>
            </el-col>-->


            <el-col style="width:180px;" class="userinfo">
                <el-col style="display: flex;width:100px;text-align:center;height:100px;flex-direction: column;">

                    <span style="margin-top:-8px;height: 20px;">欢迎您 : {{this.myInfoForm.name}}</span>
                    <span>身份 : {{this.myInfoForm.userType | formatUserType}}</span>
                </el-col>
                <el-dropdown trigger="hover">
                    <span class="el-dropdown-link userinfo-inner"><img
                            src="../assets/my.png"/></span>
                    <el-dropdown-menu slot="dropdown" style="text-align: center">
                        <el-dropdown-item @click.native="showMyInfo">个人信息</el-dropdown-item>
                        <el-dropdown-item divided @click.native="updatePasswordVisible=true">修改密码</el-dropdown-item>
                        <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>


            <!--个人信息-->
            <el-dialog title="个人信息" v-model="myInfoVisible" :close-on-click-modal="false">
                <el-form :model="myInfoForm" label-width="120px" ref="myInfoForm">

                    <el-form-item label="个人余额" v-if="accountType==2">
                        <span style="color:red;font-size:18px;">{{myInfoForm.money | formatMoney}}</span>
                        <el-button style="margin-left:30px;" type="success" @click.native="pay">立即充值</el-button>
                    </el-form-item>
                    <el-form-item label="登录账号">
                        <el-input v-model="myInfoForm.loginName" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input v-model="myInfoForm.name" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="电话">
                        <el-input v-model="myInfoForm.phone" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-form-item v-if='accountType==2' label="技术支持">
                        <el-input v-model="myInfoForm.techPhone" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="邮箱">
                        <el-input v-model="myInfoForm.email" auto-complete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="地址">
                        <el-input v-model="myInfoForm.address" auto-complete="off"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="myInfoVisible = false">取消</el-button>
                    <el-button type="primary" v-if="accountType!=2" @click.native="myInfoSubmit">提交</el-button>
                </div>
            </el-dialog>

            <!--修改密码-->
            <el-dialog title="修改密码" v-model="updatePasswordVisible" :close-on-click-modal="false">
                <el-form :model="updatePasswordForm" label-width="120px" ref="updatePasswordForm">

                    <el-row>
                        <el-col>
                            <el-form-item label="旧密码" class="require">
                                <el-input type="password" v-model="updatePasswordForm.oldPassword"
                                          auto-complete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col>
                            <el-form-item label="新密码" class="require">
                                <el-input type="password" v-model="updatePasswordForm.newPassword"
                                          auto-complete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>


                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="updatePasswordVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="updatePasswordSubmit">提交</el-button>
                </div>
            </el-dialog>

            <!--充值-->
            <el-dialog title="充值" v-model="payVisible" :close-on-click-modal="false">
                <el-form :model="payForm" label-width="120px" ref="payForm">

                    <el-row>
                        <el-col>
                            <el-form-item label="金额" class="require">
                                <el-input type="number" v-model="payForm.money"
                                          auto-complete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col>
                            <el-form-item label="备注">
                                <el-input type="text" v-model="payForm.remark"
                                          auto-complete="off"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>


                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="payVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="paySubmit">提交</el-button>
                </div>
            </el-dialog>


        </el-col>
        <el-col :span="24" class="main">
            <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
                <!--导航菜单-->
                <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen"
                         @close="handleclose" @select="handleselect"
                         unique-opened router v-show="!collapsed">
                    <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
                        <el-submenu :index="index+''" v-if="!item.leaf">
                            <template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
                            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path"
                                          v-if="!child.hidden">{{child.name}}
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i
                                :class="item.iconCls"></i>{{item.children[0].name}}
                        </el-menu-item>
                    </template>
                    <el-button @click="searchMasterWithMap" style="border:none; background: rgb(238, 246, 246);margin-left:0px;
                    color:rgb(72, 106, 103);margin-left:5px;">
                        <i class="iconfont icon-shangjia" style="font-size:18px;margin-right:5px;"></i> 安装网店查询
                    </el-button>


                </el-menu>

                <!--导航菜单-折叠后-->
                <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
                    <li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">
                        <template v-if="!item.leaf">
                            <div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)"
                                 @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
                            <ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)"
                                @mouseout="showMenu(index,false)">
                                <li v-for="child in item.children" v-if="!child.hidden" :key="child.path"
                                    class="el-menu-item" style="padding-left: 40px;"
                                    :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">
                                    {{child.name}}
                                </li>
                            </ul>
                        </template>
                        <template v-else>
                    <li class="el-submenu">
                        <div class="el-submenu__title el-menu-item"
                             style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;"
                             :class="$route.path==item.children[0].path?'is-active':''"
                             @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i>
                        </div>
                    </li>
</template>
</li>
</ul>
</aside>
<section class="content-container">

    <div class="grid-content bg-purple-light">
        <el-col :span="24" class="breadcrumb-container">
            <strong class="title">{{$route.name}}</strong>
            <el-breadcrumb separator="/" class="breadcrumb-inner">
                <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                    {{ item.name}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </el-col>
        <el-col :span="24" class="content-wrapper">

            <transition name="fade" mode="out-in">
                <!--<keep-alive>-->
                <router-view></router-view>
                <!--</keep-alive>-->
            </transition>

        </el-col>
    </div>
    <!--地图搜索工程师-->
    <el-dialog title="搜索工程师" customClass="assignWidth" v-model="searchMasterWithMapVisible"
               :close-on-click-modal="false">
        <el-form label-width="120px">

            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="searchMasterWithMapFilters">

                    <el-form-item>
                        <el-input style="width:400px;" v-model="searchMasterWithMapFilters.address"
                                  placeholder="输入详细市名+地址搜索">
                            <el-button slot="append" icon="search"
                                       @click="getPoi_searchMasterWithMap()"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-col>
            <div id="container_searchMasterWithMap" class="map">

            </div>

            <el-table :data="masterUsers_searchMasterWithMap" highlight-current-row border stripe
                      v-loading="listLoading"
                      style="width: 100%;">

                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-row>

                            <el-col :span="8">
                                <el-form label-position="left" class="demo-table-expand">
                                    <el-form-item label="付款账号">
                                        <span>{{ props.row.logistics }}</span>
                                    </el-form-item>

                                    <el-form-item label="营业时间">
                                        <span>{{ props.row.workTime }}</span>
                                    </el-form-item>
                                    <el-form-item label="服务类型">
                                        <span>{{ props.row.serviceType | formatServiceType}}</span>
                                    </el-form-item>
                                    <el-form-item label="备注">
                                        <span>{{ props.row.remark }}</span>
                                    </el-form-item>

                                </el-form>
                            </el-col>
                            <el-col :span="8">
                                <el-form label-position="left" class="demo-table-expand">
                                    <el-form-item label="图片详情">

                                        <el-button type="success" size="small"
                                                   @click="queryImage(props.row)">点击查看
                                        </el-button>

                                    </el-form-item>

                                    <el-form-item label="经营主体">
                                        <span>{{ props.row.storeInfo }}</span>
                                    </el-form-item>
                                    <el-form-item label="技能标签">
                                        <span>{{ `${typeof props.row.skills=='undefined'?'':props.row.skillsDesc}` }}</span>
                                    </el-form-item>

                                </el-form>
                            </el-col>
                            <el-col :span="8">
                                <el-form label-position="left" class="demo-table-expand">
                                    <el-form-item label="等级-积分">
                                        <span>{{ props.row.level | formatLevel}}-{{props.row.score}}</span>
                                    </el-form-item>
                                    <el-form-item label="面试方式">
                                        <span>{{ props.row.interviewType | formatInterview}}</span>
                                    </el-form-item>
                                    <el-form-item label="邀请码">
                                        <span>{{ props.row.recommendCode }}</span>
                                    </el-form-item>
                                    <el-form-item label="详细地址">
                                        <span>{{ props.row.address }}</span>
                                    </el-form-item>
                                </el-form>

                            </el-col>
                        </el-row>
                    </template>
                </el-table-column>

                <el-table-column prop="masterId" label="工程师ID" width="100">
                </el-table-column>
                <el-table-column prop="level" label="等级" width="120" :formatter="formatLevel">
                </el-table-column>
                <!-- <el-table-column prop="lastLoginTime" label="是否关注" width="120" :formatter="formatLastLoginTime">
                 </el-table-column>-->
                <el-table-column prop="storeName" label="店铺名称">
                </el-table-column>
                <el-table-column prop="distance" label="距离" width="110" :formatter="formatDistance">
                </el-table-column>
                <!--<el-table-column prop="phone" label="手机号码" width="130">
                </el-table-column>-->
                <el-table-column prop="name" label="姓名" width="130">
                </el-table-column>
                <!--<el-table-column prop="remark" label="备注" width="150">
                </el-table-column>-->
                <!--<el-table-column prop="joinTime" label="加入时间" width="200">
                </el-table-column>-->
                <el-table-column label="详细地址">
                    <template slot-scope="scope">
                        <span>{{scope.row.regionAddress.replace(/,/g,'')+""+scope.row.address}}</span>
                    </template>

                </el-table-column>
                <!--<el-table-column prop="money" label="余额" width="80" :formatter="formatMoney">
                </el-table-column>-->
                <!-- <el-table-column prop="orderCount" label="订单量" width="80">
                     <template slot-scope="scope">
                         <el-button type='info' size="small" :disabled="scope.row.orderCount==0"
                                    @click="masterDetailOrder(scope.$index, scope.row)">查看:{{scope.row.orderCount}}
                         </el-button>
                     </template>

                 </el-table-column>-->

            </el-table>

        </el-form>


    </el-dialog>

</section>
</el-col>
</el-row>


</template>

<script>
    import util from '../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../api/api';
    import {data} from "../common/data";
    import {TMap} from '../api/map'
    import gongImg from '@/assets/gong.png'
    import dingImg from '@/assets/ding.png'

    export default {
        data() {
            return {
                accountType: sessionStorage.getItem('type'),
                sysName: '后台管理',
                collapsed: false,
                updatePasswordVisible: false,
                myInfoVisible: false,
                searchMasterWithMapVisible: false,
                searchMasterWithMapFilters: {
                    address: "",
                    radius: 20000
                },
                gongImg,
                dingImg,
                listLoading: false,
                masterUsers: [],
                masterUsers_searchMasterWithMap: [],
                myInfoForm: {
                    loginName: '',
                    userId: '',
                    name: '',
                    phone: '',
                    email: '',
                    address: '',
                    techPhone: '',
                    money: ''
                },
                updatePasswordForm: {
                    oldPassword: '',
                    newPassword: ''
                },
                payVisible: false,
                payForm: {
                    rechargeType: 0,
                    money: 0,
                    remark: ''
                },

            }
        },
        filters: {
            formatMoney: function (value) {
                if (value)
                    return value / 100 + ' 元';
                else return 0 + " 元";
            },
            formatUserType: function (value) {

                switch (parseInt(value)) {
                    case 0:
                        return '管理员';
                    case 1:
                        return '员工';
                    case 2:
                        return '商家';
                    case 3:
                        return '安装人员';
                    case 4:
                        return '用户';
                    default:
                        '未知类型';
                }
            }
        },
        methods: {
            formatLevel(row) {
                return data.level[row.level].label
            },
            formatDistance(row) {
                return `${row.distance / 1000}公里`;
            },
            searchMasterWithMap() {
                let that = this;
                this.searchMasterWithMapVisible = true;
                TMap('CAMBZ-RHK3U-A77VV-4H76Z-TLOT2-Q4F34').then(qq => {
                    that.drawMark_searchMasterWithMap();
                });
            },
            drawMark_searchMasterWithMap(res) {
                let that = this;

                that.map = new qq.maps.Map(document.getElementById("container_searchMasterWithMap"), {
                    // 地图的中心地理坐标。
                    zoom: 4
                });

                if (res) {
                    this.masterUsers_searchMasterWithMap = res.data.master;

                    if (res.data.master.length > 0) {
                        var anchor = new qq.maps.Point(0, 39),
                            size = new qq.maps.Size(48, 48),
                            origin = new qq.maps.Point(0, 0),
                            gongMarker = new qq.maps.MarkerImage(
                                that.gongImg,
                                size,
                                origin,
                                anchor
                            ),
                            dingMarker = new qq.maps.MarkerImage(
                                that.dingImg,
                                size,
                                origin,
                                anchor
                            );


                        res.data.master.forEach(function (value, index) {

                            var marker = new qq.maps.Marker({
                                position: new qq.maps.LatLng(value.lat, value.lon),
                                map: that.map
                            });
                            new qq.maps.Label({
                                position: new qq.maps.LatLng(value.lat, value.lon),
                                map: that.map,
                                offset: new qq.maps.Size(48, -28),
                                style: {color: "red"},
                                content: `${value.masterId},距离:${value.distance / 1000}公里`
                            });
                            marker.setIcon(gongMarker);

                        })
                        var marker = new qq.maps.Marker({
                            position: new qq.maps.LatLng(res.data.point.lat, res.data.point.lng),
                            map: that.map,
                        });
                        marker.setIcon(dingMarker);
                        that.map.setCenter(new qq.maps.LatLng(res.data.point.lat, res.data.point.lng));
                        that.map.setZoom(15);
                    } else {
                        var anchor = new qq.maps.Point(0, 39),
                            size = new qq.maps.Size(48, 48),
                            origin = new qq.maps.Point(0, 0),
                            dingMarker = new qq.maps.MarkerImage(
                                that.dingImg,
                                size,
                                origin,
                                anchor
                            );
                        var marker = new qq.maps.Marker({
                            position: new qq.maps.LatLng(res.data.point.lat, res.data.point.lng),
                            map: that.map,
                        });
                        marker.setIcon(dingMarker);
                        that.map.setCenter(new qq.maps.LatLng(res.data.point.lat, res.data.point.lng));
                        that.map.setZoom(15);
                    }
                    //点击地图事件
                    that.registerMapClickEvent(that.map, true)
                }


            },

            registerMapClickEvent(map, isSearchMasterWithMap) {
                let that = this;
                qq.maps.event.addListener(map, 'click', function (e) {
                    var lat = e.latLng.getLat();
                    var lng = e.latLng.getLng();
                    var anchor = new qq.maps.Point(0, 39),
                        size = new qq.maps.Size(48, 48),
                        origin = new qq.maps.Point(0, 0),
                        dingMarker = new qq.maps.MarkerImage(
                            that.dingImg,
                            size,
                            origin,
                            anchor
                        );
                    var marker = new qq.maps.Marker({
                        position: new qq.maps.LatLng(lat, lng),
                        map: map,
                    });
                    marker.setIcon(dingMarker);

                    that.getNearMasterByLatLng(lat, lng, isSearchMasterWithMap);
                });


            },

            getNearMasterByLatLng(lat, lng, isSearchMasterWithMap) {
                let para = {
                    lat: lat,
                    lon: lng,
                    radius: 20000
                };
                NProgress.start();
                let url = 'order/getNearMaster.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        if (isSearchMasterWithMap)
                            this.drawMark_searchMasterWithMap(res);
                        else
                            this.drawMark(res);
                    }
                    NProgress.done();
                })
            },

            getPoi() {
                if (this.assignFilters.address != '') {
                    let para = Object.assign({}, this.assignFilters);
                    NProgress.start();
                    let url = 'master/getNearMaster.do';
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {
                            this.drawMark(res);
                        }
                        NProgress.done();
                    })
                } else {
                    let para = {
                        orderId: this.assignForm.orderId,
                        radius: 20000
                    };
                    NProgress.start();
                    let url = 'order/getNearMaster.do';
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {
                            this.drawMark(res);
                        }
                        NProgress.done();
                    })
                }


            },

            getPoi_searchMasterWithMap() {
                if (this.searchMasterWithMapFilters.address != '') {
                    let para = Object.assign({}, this.searchMasterWithMapFilters);
                    NProgress.start();
                    let url = 'master/getNearMaster.do';
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {
                            this.drawMark_searchMasterWithMap(res);
                        }
                        NProgress.done();
                    })
                } else {
                    this.$message({
                        message: '请输入详细地址查询!',
                        type: 'warning'
                    });
                }
            },
            pay() {
                this.payVisible = true;
            },
            paySubmit() {
                if (this.payForm.money <= 0) {
                    e.$message({
                        message: '请输入正确的充值金额',
                        type: 'warning'
                    });
                } else {
                    NProgress.start();
                    let url = 'recharge/create.do';
                    let para = Object.assign({}, this.payForm);
                    para.money = this.payForm.money * 100;

                    requestPost(this, url, para).then((res) => {
                        if (res != '') {
                            this.$confirm('支付成功？', '提示', {}).then(() => {
                                this.payVisible = false;
                                this.getMyInfo();
                            });
                            let routeData = this.$router.resolve({path: 'apply', query: {htmls: res}});
                            window.open(routeData.href, '_blank');
                        }
                        NProgress.done();
                    });
                }

            },
            onSubmit() {

            },
            handleopen() {
                //console.log('handleopen');
            },
            handleclose() {
                //console.log('handleclose');
            },
            handleselect: function (a, b) {
            },
            showMyInfo() {
                this.myInfoVisible = true;
                this.getMyInfo();
            },
            getMyInfo() {
                NProgress.start();
                let url = 'user/getUserInfo.do';
                requestPost(this, url, {}).then((res) => {

                    if (res != '') {

                        this.myInfoForm = res.data;
                    }

                    NProgress.done();
                });
            },
            myInfoSubmit() {
                this.$confirm('确认提交吗？', '提示', {}).then(() => {

                    NProgress.start();
                    let para = Object.assign({}, this.myInfoForm);
                    let url = 'user/update.do';
                    requestPost(this, url, para).then((res) => {

                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.getMyInfo();
                        }

                    });
                });
            },
            updatePasswordSubmit: function () {

                let para = Object.assign({}, this.updatePasswordForm);

                NProgress.start();
                let url = 'user/editPsw.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {
                        util.successTip(this);
                        this.$refs['updatePasswordForm'].resetFields();
                        this.updatePasswordVisible = false;
                    }

                    NProgress.done();
                });

            },
            //退出登录
            logout: function () {
                var _this = this;
                this.$confirm('确认退出吗?', '提示', {
                    //type: 'warning'
                }).then(() => {
                    _this.$router.push('/login');
                }).catch(() => {

                });
            },


            //折叠导航栏
            collapse: function () {
                this.collapsed = !this.collapsed;
            },
            showMenu(i, status) {
                this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
            }
        },
        mounted() {
            this.getMyInfo();
        },
        created() {
            /*0	系统管理员
            1	员工
            2	商家*/

            this.$router.options.routes[2].hidden = false;
            this.$router.options.routes[4].hidden = false;
            this.$router.options.routes[2].children[1].hidden = false;
            this.$router.options.routes[5].hidden = false;
            this.$router.options.routes[1].hidden = false;
            this.$router.options.routes[6].children[1].hidden = false;
            this.$router.options.routes[6].children[2].hidden = true;

            if (sessionStorage.getItem('type') == 1) {
                this.$router.options.routes[2].children[1].hidden = true;
                this.$router.options.routes[1].children[1].hidden = true;
            } else if (sessionStorage.getItem('type') == 2) {

                this.$router.options.routes[2].hidden = true;
                this.$router.options.routes[4].hidden = true;
                this.$router.options.routes[5].hidden = true;
                this.$router.options.routes[1].children[1].hidden = true;
                this.$router.options.routes[6].children[1].hidden = true;
                this.$router.options.routes[6].children[2].hidden = true;
                this.$router.options.routes[3].children[1].hidden = true;
                this.$router.options.routes[3].children[2].hidden = true;
                this.$router.options.routes[3].children[3].hidden = true;

            }

        }
    }

</script>

<style scoped lang="scss" type="text/scss">
    @import '../styles/vars.scss';

    .container {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%;
        .header {
            height: 60px;
            line-height: 60px;
            background: $color-primary;
            color: #fff;
            .userinfo {
                text-align: right;
                padding-right: 35px;
                float: right;
                .userinfo-inner {
                    cursor: pointer;
                    color: #fff;
                    img {
                        width: 35px;
                        height: 35px;
                        border-radius: 20px;
                        margin: 15px 0px 10px 10px;
                        float: right;
                    }
                }
            }
            .logo {
                //width:230px;
                height: 60px;
                font-size: 22px;
                padding-left: 20px;
                padding-right: 20px;
                border-color: rgba(238, 241, 146, 0.3);
                border-right-width: 1px;
                border-right-style: solid;
                img {
                    width: 40px;
                    float: left;
                    margin: 10px 10px 10px 18px;
                }
                .txt {
                    color: #fff;
                }
            }
            .logo-width {
                width: 230px;
            }
            .logo-collapse-width {
                width: 60px
            }
            .tools {
                padding: 0px 23px;
                width: 14px;
                height: 60px;
                line-height: 60px;
                cursor: pointer;
            }
        }
        .main {
            display: flex;
            // background: #324057;
            position: absolute;
            top: 60px;
            bottom: 0px;
            overflow: hidden;
            aside {
                flex: 0 0 230px;
                width: 230px;
                // position: absolute;
                // top: 0px;
                // bottom: 0px;
                .el-menu {
                    height: 100%;
                }
                .collapsed {
                    width: 60px;
                    .item {
                        position: relative;
                    }
                    .submenu {
                        position: absolute;
                        top: 0px;
                        left: 60px;
                        z-index: 99999;
                        height: auto;
                        display: none;
                    }

                }
            }
            .menu-collapsed {
                flex: 0 0 60px;
                width: 60px;
            }
            .menu-expanded {
                flex: 0 0 230px;
                width: 230px;
            }
            .content-container {
                // background: #f1f2f7;
                flex: 1;
                // position: absolute;
                // right: 0px;
                // top: 0px;
                // bottom: 0px;
                // left: 230px;
                overflow-y: scroll;
                padding: 20px;
                .breadcrumb-container {
                    //margin-bottom: 15px;
                    .title {
                        width: 200px;
                        float: left;
                        color: #475669;
                    }
                    .breadcrumb-inner {
                        float: right;
                    }
                }
                .content-wrapper {
                    background-color: #fff;
                    box-sizing: border-box;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// Home.vue?6943664a